// extracted by mini-css-extract-plugin
export default {"main":"SplashPage_main__ELGFM"};